import Choices from 'choices.js';
import { choicesConfig } from './Form/CustomSelect';

$(document).ready(function () {
  const $filter = $('select.ApartmentFilter');
  $filter.each((i, element) => new Choices(element, choicesConfig));
  $filter.change(function () {
    var selected = $(this).children('option:selected').val();
    var selectedKey = selected.split('=')[0];
    var selectedValue = selected.split('=')[1];

    insertParam(selectedKey, selectedValue);
  });

  //Sort options in price dropdown filter
  let options = [];
  $('div').each(function (index) {
    let dataValue = $(this).attr('data-value');
    let regExp = new RegExp('maximaler Preis=bis ([0-9]*)', 'g');
    if (regExp.test(dataValue)) {
      regExp = new RegExp('maximaler Preis=bis ([0-9]*)', 'g');
      let match = regExp.exec(dataValue);
      options[match[1]] = $(this);
    }
  });

  $('div').each(function (index) {
    let dataValue = $(this).attr('data-value');
    let regExp = new RegExp('maximaler Preis=bis ([0-9]*)', 'g');
    if (regExp.test(dataValue)) {
      for (let key in options) {
        $(this).parent().append(options[key]);
      }
    }
  });
});

/**
 * Insert selected key and value to GET parameters when they don't exist, otherwise change them and reload the new page.
 * @param key
 * @param value
 */
function insertParam(key, value) {
  key = key.replace(/ä/g, 'ae');
  key = key.replace(/ö/g, 'oe');
  key = key.replace(/ü/g, 'ue');

  let urlSearchParams = new URLSearchParams(window.location.search.slice(1));

  if (value === 'empty') {
    urlSearchParams.delete(key);
  } else {
    urlSearchParams.set(key, value);
  }

  document.location.search = urlSearchParams.toString();
}
